import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { SpeedOfServiceMetricsModel } from '@/types'

export const getSpeedOfServiceMetrics = async (
  branchName: string,
  startDate: string,
  endDate: string
): Promise<SpeedOfServiceMetricsModel[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/speed-of-service`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        branch_names: branchName,
        limit: 1000,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
